import { createAction } from "@reduxjs/toolkit"
import { RenderState } from "@fusion-advantage/formrender"

export const updateRenderState = createAction<Partial<RenderState>>('render/updateRenderState')
